import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ChoiceChip from '../../choice-chip';
import { getCharByElementPosition } from '../../../lib/exercise';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';
import Stack from '../../stack';
import { SingleFillBlankFeedback } from '../fill-blanks';

const Label = styled.span`
    display: inline-block;
    font-weight: 600;
    margin-right: 4px;
    margin-top: 8px;
`;

const Feedback = styled.span`
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 8px;
`;

export const CorrectChoiceChip = styled.span`
    margin-top: 8px;
`;

const getLabel = (missedAnswer, correct) => {
    if (missedAnswer) {
        return 'Risposta non data.';
    }

    return correct ? 'Risposta corretta.' : 'Risposta sbagliata.';
};

export const ChipFeedback = ({ id, correct, correctAnswer, feedback, index, missedAnswer, text, useIconsForValidation }) => {
    return (
        <div>
            <ChoiceChip
                id={id}
                key={`${index}`}
                badgeIndex={getCharByElementPosition(index + 1)}
                useIconsForValidation={useIconsForValidation}
                handleClick={() => {}}
                value={text}
                type="validated"
                validationType={missedAnswer ? 'missing' : correct ? 'success' : 'error'}
            />
            <FluidContainer flexDirection="column" marginLeft="regular">
                <div>
                    <Label>{getLabel(missedAnswer, correct)}</Label>
                    {feedback && (
                        <Feedback>
                            <MathContent style={{ display: 'inline', whiteSpace: 'break-spaces' }}>{feedback}</MathContent>
                        </Feedback>
                    )}
                </div>

                {!correct && !missedAnswer && (
                    <FluidContainer flexDirection="column">
                        <Label>{'La risposta esatta è:'}</Label>
                        <CorrectChoiceChip>
                            <ChoiceChip
                                id={`${correctAnswer?.id}`}
                                type="validated"
                                validationType="missing"
                                value={correctAnswer?.text}
                                useIconsForValidation={useIconsForValidation}
                            />
                        </CorrectChoiceChip>
                    </FluidContainer>
                )}
            </FluidContainer>
        </div>
    );
};

ChipFeedback.propTypes = {
    id: PropTypes.string,
    correct: PropTypes.bool,
    correctAnswer: PropTypes.object,
    feedback: PropTypes.string,
    index: PropTypes.number,
    missedAnswer: PropTypes.bool,
    text: PropTypes.string,
    useIconsForValidation: PropTypes.bool,
};

const FillChoiceFeedback = ({ exercise, answers }) => {
    return (
        <FluidContainer flexDirection="column" marginRight="regular" marginTop={['mobile', 'mobile', 'desktop']} paddingBottom="mobile">
            <Stack gap="regular">
                {exercise.options.map((option, index) => {
                    const groupSelected = answers.find((answer) => answer.gapId === option.id);
                    const correctAnswer = option.values.find((el) => el.correct);
                    const selectedAnswer = groupSelected
                        ? option.values.find((el) => `${el.id}` === groupSelected.optionId)
                        : option.values.find((el) => el.correct);
                    const isMissedAnswer = !groupSelected;
                    return exercise.useSelect ? (
                        <SingleFillBlankFeedback
                            key={option.id}
                            id={option.id}
                            index={index}
                            missedAnswer={isMissedAnswer}
                            text={selectedAnswer.text}
                            correct={selectedAnswer.id === correctAnswer.id}
                            feedback={option.feedback}
                            correctAnswer={correctAnswer.text}
                        />
                    ) : (
                        <ChipFeedback
                            key={option.id}
                            id={option.id}
                            correct={selectedAnswer.correct}
                            correctAnswer={correctAnswer}
                            feedback={option.feedback}
                            index={index}
                            missedAnswer={!groupSelected}
                            text={selectedAnswer.text}
                            useIconsForValidation={false}
                        />
                    );
                })}
            </Stack>
        </FluidContainer>
    );
};

FillChoiceFeedback.propTypes = {
    answers: PropTypes.array,
    exercise: PropTypes.object,
};

export default FillChoiceFeedback;
